import React from 'react';
import styled from "styled-components";
import Colours from '@shared/ui/atoms/Colours';
import { CarParkPlanBooking, CarParkSpace } from '@features/whereabouts/services/CarParkingPlanService';
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import { Column, Row } from '@shared/ui/atoms/StructuralLayout';
import { WithParkingSpaceBooking } from "./WithParkingSpaceBooking";


interface Props {
  carParkingSpace?: CarParkSpace;
  carParkBookings: CarParkPlanBooking[];
}

export function HoveringCarParkingSpaceOverlay(props: Props) {
  const { carParkingSpace, carParkBookings } = props;
  const {amBooking, pmBooking, allDayBooking} = WithParkingSpaceBooking(carParkBookings, carParkingSpace)

  if (!carParkingSpace) {
    return null;
  }

  if (!amBooking && !pmBooking && !allDayBooking) {
    return null;
  }

  return (
    <Popup style={{ left: carParkingSpace.x + carParkingSpace.width * 2, top: carParkingSpace.y, zIndex: 999999 }} onClick={(e: any) => e.stopPropagation()}>
      <PopupContent>
        {!!allDayBooking ? <>
          <BodyRegular weight={600} colour={Colours.white}>{allDayBooking.name}</BodyRegular>
          {allDayBooking.jobTitle && <BodyRegular weight={600} colour={Colours.white}>{allDayBooking.jobTitle}</BodyRegular>}
          <BodyRegular weight={600} colour={Colours.white}>{allDayBooking.label}</BodyRegular>
        </> : <>
          <Row>
            <Column style={{marginRight: 4}}>
              <BodyRegular weight={600} colour={Colours.white}>AM:</BodyRegular>
            </Column>
            <Column>
              {!!amBooking ? <>
                <BodyRegular weight={600} colour={Colours.white}>{amBooking.name}</BodyRegular>
                {amBooking.jobTitle && <BodyRegular colour={Colours.white}>{amBooking.jobTitle}</BodyRegular>}
                <BodyRegular colour={Colours.white}>{amBooking.label}</BodyRegular>
              </> : <BodyRegular colour={Colours.white}>Available</BodyRegular>}
            </Column>
          </Row>
          <Row>
            <Column style={{marginRight: 4}}>
              <BodyRegular weight={600} colour={Colours.white}>PM:</BodyRegular>
            </Column>
            <Column>
              {!!pmBooking ? <>
                <BodyRegular weight={600} colour={Colours.white}>{pmBooking.name}</BodyRegular>
                {pmBooking.jobTitle && <BodyRegular colour={Colours.white}>{pmBooking.jobTitle}</BodyRegular>}
                <BodyRegular colour={Colours.white}>{pmBooking.label}</BodyRegular>
              </> : <BodyRegular colour={Colours.white}>Available</BodyRegular>}
            </Column>
          </Row>
        </>}
      </PopupContent>
    </Popup>
  )
}

const Popup = styled.div<any>`
  min-width: 220px;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 10px 14px 0 rgba(0, 0, 0, 0.25);
  background-color: ${Colours.darkBlue};
  position: absolute;
  z-index: 150;
  overflow: hidden;
`

const PopupContent = styled.div<any>`
  padding: 8px 12px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`
